import { call, put, takeLatest, takeEvery, select } from 'redux-saga/effects'
import PARTNER_PROGRAM_API from 'api/partner-program/v1'
import extractErrors from 'utils/extractErrors'
import {
  CALCULATE_AWARDS,
  GET_AD_NETWORKS_TYPES,
} from 'modules/PartnersProgram/types'
import { notificationShow } from 'modules/Notifications/actions'
import {
  setAdNetworksTypesAction,
  setCalculateAwardsAction,
} from 'modules/PartnersProgram/actions'

function* getAdNetworksTypesWorker({ payload }) {
  const { partner } = payload

  const partnerType = `types_partner_${partner}`

  try {
    yield put(
      setAdNetworksTypesAction({
        [partnerType]: {
          loading: true,
          loaded: false,
          failed: false,
        },
      }),
    )

    const { response, error } = yield call(
      PARTNER_PROGRAM_API.fetchAdNetworksTypes,
      { params: payload },
    )

    if (error) {
      throw error
    }

    if (response) {
      yield put(
        setAdNetworksTypesAction({
          [partnerType]: {
            data: response.data,
            loaded: true,
            loading: false,
          },
        }),
      )
    }
  } catch (error) {
    const { fields, form } = extractErrors(error.errors)

    yield put(
      setAdNetworksTypesAction({
        [partnerType]: {
          loading: false,
          failed: true,
          loaded: true,
        },
      }),
    )

    if (Object.keys(fields).length) {
      return
    }

    yield put(
      notificationShow({
        type: 'error',
        message: form || 'common::notifications.data_fetch_failed',
      }),
    )

    console.logXHR(error)
  }
}

export function* calculateAwardsWorker({ payload }) {
  const params = { data: payload.types }
  const { awards = {} } = yield select((state) => state['partners-program'])

  try {
    yield put(
      setCalculateAwardsAction({
        awards: {
          ...awards,
          loading: true,
          failed: false,
          loaded: false,
        },
      }),
    )

    const { response, error } = yield call(
      PARTNER_PROGRAM_API.calculateAwards,
      params,
    )

    if (error) {
      throw error
    }

    if (response) {
      yield put(
        setCalculateAwardsAction({
          awards: {
            data: { ...response.summary },
            loaded: true,
            loading: false,
          },
        }),
      )
    }
  } catch (error) {
    const { fields, form } = extractErrors(error.errors)

    yield put(
      setCalculateAwardsAction({
        awards: {
          loading: false,
          failed: true,
          loaded: true,
        },
      }),
    )

    if (Object.keys(fields).length) {
      return
    }

    yield put(
      notificationShow({
        type: 'error',
        message: form || 'common::notifications.data_fetch_failed',
      }),
    )

    console.logXHR(error)
  }
}

export default function* PartnersProgram() {
  yield takeEvery(GET_AD_NETWORKS_TYPES, getAdNetworksTypesWorker)
  yield takeLatest(CALCULATE_AWARDS, calculateAwardsWorker)
}
